/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class InvoiceCancelSelectVo extends JSONable{
  uuid: string | undefined = undefined;
  invoiceSeries: string | undefined = undefined;
  currencyCode: string | undefined = undefined;
  totalPrice: number | undefined = undefined;
  issueDate: string | undefined = undefined;

  invoiceSummary: string | undefined = undefined;
}
